const base = {
  appearance: 'none',
  outline: 'none',
  display: 'inline-block',
  textAlign: 'center',
  lineHeight: 'inherit',
  textDecoration: 'none',
  variant: 'text.bodySansSerif',
  fontWeight: 500,
  fontSize: 'inherit',
  fontFamily: 'body',
  m: 0,
  px: 3,
  py: 2,
  border: 0,
  transitionProperty: 'opacity, box-shadow, transform, background-color',
  transitionDuration: '150ms',
  transitionTimingFunction: 'ease-out',
  '&[disabled]': {
    opacity: 0.5,
    boxShadow: 'none',
    pointerEvents: 'none',
  },
  '&:focus': {
    boxShadow: 'outline',
  },
}

export const button = {
  base,
  nav: {
    ...base,
  },
  primary: {
    ...base,
    color: 'secondary',
    background: 'linear-gradient(to bottom, #FFD17F 0, #FF8D00 100%)',
    py: '15px',
    borderRadius: '15px',
    fontSize: 2,
    width: '233px',
    letterSpacing: 'button',
  },
}
